import React, { FC, ReactNode } from 'react'
import { ModalContent, ModalActions } from '@lightspeed/design-system-react'

const heightStyle = { height: 300 }

interface Props {
  children: ReactNode
  actions?: ReactNode
}

export const EcomModalContent: FC<Props> = ({ children, actions }) => (
  <ModalContent>
    <div
      className="vd-flex vd-flex--column vd-flex--align-center"
      style={heightStyle}
    >
      <div className="vd-flex vd-flex--column vd-flex--align-center vd-flex--justify-center">
        {children}
      </div>
      {actions && <ModalActions>{actions}</ModalActions>}
    </div>
  </ModalContent>
)
